import PremiumInsightsProvider from './PremiumInsightsProvider'
import Insights from './components/Insights'

export default function PremiumInsights() {
  return (
    <PremiumInsightsProvider>
      <Insights />
    </PremiumInsightsProvider>
  )
}
